<template>
  <div class="event-info">
    <Card>
      <h2 style="text-align: center;margin:20px 0 0 0;">事件上报</h2>
      <!--      <h2 v-else style="text-align: center;margin:20px 0 0 0;">修改应急队伍</h2>-->
      <Divider/>
      <div style="width: 70%;margin: 0 auto">
        <Form ref="formValidate" :model="formValidate" :rules="ruleValidate" :label-width="150">
          <FormItem label="事件名称" prop="name">
            <Input v-model="formValidate.name" placeholder="请填写事件名称"></Input>
          </FormItem>
          <FormItem label="事件接收时间" prop="establishedTime">
            <DatePicker transfer type="datetime" placeholder="请选择事件接收时间" v-model="formValidate.establishedTime"></DatePicker>
          </FormItem>
          <FormItem label="上报人" prop="name">
            <Input v-model="formValidate.name" placeholder="请填写上报人"></Input>
          </FormItem>
          <FormItem label="上报电话" prop="name">
            <Input v-model="formValidate.name" placeholder="请填写上报电话"></Input>
          </FormItem>
          <FormItem label="事件属性" prop="name">
            <Input v-model="formValidate.name" placeholder="请填写事件属性"></Input>
          </FormItem>
          <FormItem label="经纬度">
            <Row :gutter="4">
              <Col :span="3">
                <Button type="primary" @click="">定位</Button>
              </Col>
              <Col :span="8">
                <FormItem prop="longitude">
                  <Input v-model="formValidate.longitude" placeholder="请填写经度"></Input>
                </FormItem>
              </Col>
              <Col :span="8">
                <FormItem prop="dimension">
                  <Input v-model="formValidate.dimension" placeholder="请填写纬度"></Input>
                </FormItem>
              </Col>
            </Row>
          </FormItem>
          <FormItem label="事发区域" prop="name">
            <Input v-model="formValidate.name" placeholder="请填写事发区域"></Input>
          </FormItem>
          <FormItem label="事件类型" prop="teamType">
            <Select transfer v-model="formValidate.teamType" placeholder="请选择事件类型">
              <Option v-for="item in eventTypeList" :value="item.id">{{item.name}}</Option>
            </Select>
          </FormItem>
          <FormItem label="事件描述" prop="dutyTelephone">
            <Input v-model="formValidate.dutyTelephone" placeholder="请填写事件描述，包括原因、路产损失情况、交通状况、人员伤亡情况" type="textarea" :autosize="{minRows: 3}"></Input>
          </FormItem>
          <FormItem label="事件等级" prop="teamType">
            <Select transfer v-model="formValidate.teamType" placeholder="请选择事件等级">
              <Option v-for="item in eventLevelList" :value="item.id">{{item.name}}</Option>
            </Select>
          </FormItem>
          <FormItem label="事件情况" prop="dutyTelephone">
            <Input v-model="formValidate.dutyTelephone" placeholder="请填写事件情况" type="textarea" :autosize="{minRows: 3}"></Input>
          </FormItem>
          <FormItem label="处置建议" prop="dutyTelephone">
            <Input v-model="formValidate.dutyTelephone" placeholder="请填写处置建议" type="textarea" :autosize="{minRows: 3}"></Input>
          </FormItem>
          <FormItem label="是否应急演练" prop="dutyTelephone">
            <RadioGroup v-model="formValidate.dutyTelephone">
              <Radio label="1">是</Radio>
              <Radio label="0">否</Radio>
            </RadioGroup>
          </FormItem>
          <FormItem label="接警中心" prop="name">
            <Input v-model="formValidate.name" placeholder="请填写接警中心"></Input>
          </FormItem>
          <FormItem label="事件状态" prop="teamType">
            <Input v-model="formValidate.name" placeholder="请填写事件状态"></Input>
          </FormItem>
          <FormItem label="联系人（小组）" prop="teamType">
            <Select transfer multiple v-model="formValidate.teamType" placeholder="请选择联系人（小组）">
              <Option v-for="item in groupList" :value="item.id">{{item.name}}</Option>
            </Select>
          </FormItem>
          <FormItem label="上报区县" prop="responsibleAreaId">
            <Select transfer multiple clearable v-model="formValidate.responsibleAreaId" placeholder="区县">
              <Option v-for="(item) in countryList" :value="item.id">{{ item.name }}</Option>
            </Select>
          </FormItem>
        </Form>
        <div style="text-align: center">
          <Button type="primary" @click="handleSubmit('formValidate')">上报</Button>
          <!--            <Button v-if="teamInfo.id" type="primary" @click="editTeam('formValidate')">编辑</Button>-->
          <Button @click="handleReset('formValidate')" style="margin-left: 8px">重置</Button>
        </div>
      </div>
    </Card>
  </div>
</template>

<script>
export default {
  name: "eventInfo",
  data(){
    return {
      countryList: [],
      eventTypeList: [],
      eventLevelList: [],
      groupList: [],
      formValidate: {
        name: '',
        responsibleUnitId: '',
        personInCharge: '',
        personInChargePhone: '',
        dutyTelephone: '',
        countPeople: '',
        teamType: 0, //1-政府队伍，2-企业队伍，3-社会队伍
        establishedTime: '',
        responsibleAreaId: [],
        responsibleStreetId: '',
        address: '',
        longitude: '',
        dimension: '',
        applicableEventTypes: 1,
        superviseLevel: 1,//1-市级，2-区县级，3-镇街级
        introduce: '',
        remarks: '',
        annex: ''
      },
      ruleValidate: {},
    }
  },
  mounted() {
    this.getCountry()
    this.getEventType()
    this.getEventLevel()
    this.getNotifyGroup()
  },
  methods:{
    //区县
    getCountry() {
      this.$http.get('/api/countys').then(res => {
        // console.log(res)
        this.countryList = res.data.data
      })
    },
    getEventType() {
      this.$http.get('/api/eventTypes').then(res => {
        // console.log(res)
        if (res.status === 200) {
          this.eventTypeList = res.data.data
        }
      })
    },
    getEventLevel() {
      this.$http.get('/api/eventLevels').then(res => {
        // console.log(res)
        if (res.status === 200) {
          this.eventLevelList = res.data.data
        }
      })
    },
    getNotifyGroup() {
      this.$http.get('/api/noticeGroups').then(res => {
        // console.log(res)
        if (res.status === 200) {
          this.groupList = res.data.data
        }
      })
    },
    handleSubmit(name) {
      this.$refs[name].validate((valid) => {
        if (valid) {
          // this.$http.post('/api/team/emergencyTeams', this.formValidate).then(res => {
          //   if (res.status === 200 || res.status === 201) {
          //     this.$Message.success('新增完成！')
          //     // 跳转关闭当前页
          //     this.$store.commit('app/closePage', {
          //       vm: this,
          //       fromName: this.$route.name,
          //       toName: 'emergencyTeam'
          //     })
          //   } else {
          //     this.$Message.error(res.data.message)
          //   }
          // })
        } else {
          this.$Message.error('Fail!');
        }
      })
    },
    editTeam(name) {
      this.$refs[name].validate((valid) => {
        if (valid) {
          // this.$http.put('/api/team/emergencyTeams', this.formValidate).then(res => {
          //   if (res.status === 200 || res.status === 201) {
          //     this.$Message.success('修改完成！')
          //     // 跳转关闭当前页
          //     this.$store.commit('app/closePage', {
          //       vm: this,
          //       fromName: this.$route.name,
          //       toName: 'emergencyTeam'
          //     })
          //   } else {
          //     this.$Message.error(res.data.message)
          //   }
          // })
        } else {
          this.$Message.error('Fail!');
        }
      })
    },
    handleReset(name) {
      this.$refs[name].resetFields();
    },
  }
}
</script>

<style scoped>

</style>
